import { FC } from "react";

import { Stack, TextField } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { FilterTriggerComponentProps } from "@/components/common/select/dropdown-select/utils/types/filterTriggerComponentProps";
import {
  costTypes,
  getTitleByCostTypeAndProvider,
} from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/utils/constants";
import { CostType, ProviderType } from "@/services/cloudchipr.api";
import { CostTypeSelectItemProviders } from "@/components/pages/resource-explorer/components/settings-panel/components/cost-type-settings-section/CostTypeSelectItemProviders";

interface CostTypeSelectTextFieldTriggerComponentProps
  extends FilterTriggerComponentProps {
  workFor?: Extract<ProviderType, "aws" | "azure">;
  size?: "small" | "medium";
}

export const CostTypeSelectTextFieldTriggerComponent: FC<
  CostTypeSelectTextFieldTriggerComponentProps
> = ({ selectedValues, open, onClick, workFor, size, label }) => {
  const firstSelectedValue = selectedValues[0] as CostType;
  const providers = costTypes?.[firstSelectedValue]?.providers;

  const value = getTitleByCostTypeAndProvider(
    costTypes[firstSelectedValue]?.label,
    firstSelectedValue,
    workFor,
  );

  return (
    <TextField
      size={size === "small" ? "xsmall" : "small"}
      label={label}
      onClick={onClick}
      contentEditable={false}
      value={value ?? label}
      InputProps={{
        readOnly: true,
        inputProps: {
          style: {
            paddingLeft: 8,
            cursor: "pointer",
            caretColor: "transparent",
            textOverflow: "ellipsis",
            overflow: "hidden",
          },
        },
        sx: {
          pr: 1,
          cursor: "pointer",
          minWidth: 175,
          fontSize: size === "medium" ? 16 : 14,
          pl: 1,
        },
        endAdornment: (
          <Stack direction="row" spacing={1}>
            {!workFor && (
              <CostTypeSelectItemProviders
                providers={providers ?? []}
                hideTooltip
              />
            )}
            {open ? (
              <ArrowDropUpIcon color="action" />
            ) : (
              <ArrowDropDownIcon color="action" />
            )}
          </Stack>
        ),
      }}
    />
  );
};
